import z from 'zod'
import { decimalSchema } from '../../utils/schema'

/** Binance Convert History の単一レコード */
export const convertHistoryItemSchema = z.object({
  /** 見積もりID */
  quoteId: z.string(),
  /** 注文ID */
  orderId: z.number(),
  /** 注文ステータス (SUCCESS など) */
  orderStatus: z.string(),
  /** 変換前のアセット */
  fromAsset: z.string(),
  /** 変換前の数量 (Decimal) */
  fromAmount: decimalSchema,
  /** 変換後のアセット */
  toAsset: z.string(),
  /** 変換後の数量 (Decimal) */
  toAmount: decimalSchema,
  /** 価格比率 (from -> to) (Decimal) */
  ratio: decimalSchema,
  /** 逆価格比率 (to -> from) (Decimal) */
  inverseRatio: decimalSchema,
  /** 作成時刻（ミリ秒） */
  createTime: z.number(),
})

/** Binance Convert History API レスポンススキーマ */
export const responseSchema = z.object({
  /** 変換履歴のリスト */
  list: z.array(convertHistoryItemSchema),
  /** 開始時刻（ミリ秒） */
  startTime: z.number(),
  /** 終了時刻（ミリ秒） */
  endTime: z.number(),
  /** 取得件数 */
  limit: z.number(),
  /** 追加データの有無 */
  moreData: z.boolean(),
})
